import { WechatUnreadNumUpdateData } from "../../handler/wechat/ws-types";
import EventBus from "../event-bus";
const unreadNumUpdateHook = new EventBus<WechatUnreadNumUpdateData>(
  "unreadNumUpdateHook"
);

export default unreadNumUpdateHook;
